import { useTrEnumNamespace as e } from "./useTrEnumNamespace.mjs";
//#region src/enums/useTrGuestDocumentRetentionHint.ts
var t = () => e("guestDocumentRetentionHint");
//#endregion
export { t as useTrGuestDocumentRetentionHint };
